import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { runtimeEventManager } from '@wm/core';
import { getActionFromKey } from '@wms/app/core';
import { AppRef } from "@wms/design-container";
import { DialogService, ProjectService } from "@wms/services";
import { WmsDialogComponent, WmsDeletePrefabFromProjectComponent } from "@wms/components";

@Component({
  selector: 'wms-help-panel',
  standalone: true,
  templateUrl: './wms-help-panel.component.html',
  styleUrls: ['./wms-help-panel.component.less'],
  imports: [
    CommonModule,
    WmsDialogComponent,
    WmsDeletePrefabFromProjectComponent
  ],
  host: { class: 'wms-help-panel-container' }
})
export class WmsHelpPanelComponent extends BaseComponent {
  isWidgetProp: any = false;
  widgetInfo: any;
  helpPanel: any = {};
  showPanel: boolean = false;
  WIDGET_DOCS: string = 'https://www.wavemaker.com/learn/app-development/widgets/';
  dialogParams: any;

  constructor(public appRef: AppRef, private dialogService: DialogService) {
    super();
    runtimeEventManager.on('wms:show-widget-help').subscribe((details: any) => {
      this.showPanel = true;
      if (details.type === 'widget') {
        this.isWidgetProp = true;
        this.widgetInfo = details.widgetInfo;
        this.helpPanel.name = this.widgetInfo.namekey || this.widgetInfo.name;
        this.helpPanel.isPrefab = this.widgetInfo.widgetType === 'wm-prefab';
        this.helpPanel.apiDocLink = this.widgetInfo.apiDocLink;
        this.helpPanel.widgetDocLink = this.widgetInfo.widgetDocLink;
        this.helpPanel.info = this.locale['WIDGET_HELP_TEXT_' + this.widgetInfo.widgetType.toUpperCase()] ||
          this.locale['WIDGET_HELP_TEXT_WM-' + this.widgetInfo.name.toUpperCase()] ||
          this.locale[this.widgetInfo.namekey] ||
          this.widgetInfo.desc ||
          this.widgetInfo.displayName ||
          this.widgetInfo.name;
      } else {
        this.isWidgetProp = false;
        let propertyInfo = details.propertyInfo;
        this.helpPanel.name = propertyInfo.name;
        this.helpPanel.info = propertyInfo.info;
      }
      this.deregisterEvents();
      this.registerEvents();
    });
    runtimeEventManager.on('wms:hide-widget-help').subscribe(() => {
      this.deregisterEvents();
      this.showPanel = false;
    })
    this.appRef.getStudioInfo();
  }

  registerEvents = () => {
    document.body.addEventListener('click', this.onDocClick, true);
    document.body.addEventListener('keydown', this.onEscKey, true);
  }

  deregisterEvents = () => {
    document.body.removeEventListener('click', this.onDocClick, true);
    document.body.removeEventListener('keydown', this.onEscKey, true);
  }

  onDocClick = (e: any) => {
    var $target = $(e.target);
    if (!$target.is('.wms-help-panel *:not(.wms-clear), li.widget *, li.widget')) {
      runtimeEventManager.emit('wms:hide-widget-help');
    }
  }

  onEscKey = (e: any) => {
    if (getActionFromKey(e) === 'ESC') {
      runtimeEventManager.emit('wms:hide-widget-help');
    }
  }

  closeDialogWithId = (id: string) => {
    this.dialogService.close(id);
  }

  deletePrefabFromProject = (event: any, prefabObj: any) => {
    event.stopPropagation();
    event.preventDefault();

    runtimeEventManager.emit('wms:hide-widget-help');

    this.dialogParams = {
      prefabData  : prefabObj,
      projectId   : this.projectService.getProjectId()
    }
    this.dialogService.open('deletePrefabFromProjectDialog');
  }
}
